import React, { FC } from 'react';
import { Autocomplete, TextField, Chip, MenuItem } from '@mui/material';

interface SubjectSelectProps {
  tComp: (key: string) => string;
  allDMSchoolSubjects: string[];
  selectedDMSchoolSubjects: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  autocompleteItemStyle: (selected: boolean) => any;
  handleDMSchoolSubjectsChanged: (subjects: string[]) => void;
}

const SubjectSelect: FC<SubjectSelectProps> = ({
  tComp,
  allDMSchoolSubjects,
  selectedDMSchoolSubjects,
  autocompleteItemStyle,
  handleDMSchoolSubjectsChanged,
}) => {
  return (
    <Autocomplete
      multiple
      options={allDMSchoolSubjects}
      getOptionLabel={(option) => tComp(`DMBlock.School.Subject.Options.${option}`)}
      value={selectedDMSchoolSubjects}
      onChange={(_, v) => handleDMSchoolSubjectsChanged(v)}
      renderInput={(params) => (
        <TextField {...params} label={tComp('DMBlock.School.Subject.SelectSubject')} size='small' />
      )}
      renderValue={(value: string[], getItemProps) =>
        value.map((option: string, index: number) => (
          <Chip size='small' {...getItemProps({ index })} key={option} label={option} />
        ))
      }
      renderOption={(props, option, { selected }) => (
        <li {...props} style={autocompleteItemStyle(selected)}>
          {option}
        </li>
      )}
      fullWidth
      disableCloseOnSelect
    />
  );
};

export default SubjectSelect;
